import ModalFaqs from 'components/ModalFaqs/styled';

export default ModalFaqs;
